export const handleChangeBechmarkFiltering = (state, payload) => {
    if (payload.isFromSaveFilter) {
        return {
            ...state,
            benchmarkFilters: {
                ...state.benchmarkFilters,
                ...payload.changedItem

            }

        }
    }
    else {
        return {
            ...state,
            benchmarkFiltersAnalysis: {
                ...state.benchmarkFiltersAnalysis,
                ...payload.changedItem
            }
        }
    }

}

export const handleChangeSampleCommentsFilter = (state, payload) => {
    return {
        ...state,
        sampleCommentsFilters: {
            ...state.sampleCommentsFilters,
            ...payload
        }
    }
}

export const handleReassignExistingData = (state, payload) => {
    return {
        ...state,
        benchmarkFilters: {
            ...state.benchmarkFilters,
            ...payload


        }

    }
}